import { useEffect } from "react";
import { Button, Col, Modal, notification, Row } from "antd";
import useRequest from "../../../../hooks/useRequest";

export default function DeclineEvidenceView(props) {
  const { setOpenDecline, openDecline, dataToDecline, onRefetch, setFaltante, faltante } = props;

  const [api, contextHolder] = notification.useNotification();

  const openNotificationWithIcon = (type, message, description = "") => {
    api[type]({
      message: message,
      description: description,
    });
  };

  const { request, loading, success } = useRequest();

  const handleCloseDecline = () => {
    setOpenDecline(false);
  };

  const handleDecline = async () => {
    await request({
      endPoint: "faltante/evidencia",
      method: "put",
      data: {
        FCCODIGOFALTANTE: dataToDecline.codigoFaltante,
        FIEVIDENCIAID: dataToDecline.evidenciaId,
        FIESTATUSID: 2,
      },
    });
  };

  useEffect(() => {
    if (success) {
      onRefetch();
      handleCloseDecline();
      openNotificationWithIcon("success", "Evidencia rechazada");

      setTimeout(() => {
        setFaltante({
          ...faltante,
          open: true,
        });
      }, 100);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]);

  return (
    <>
      {contextHolder}
      <Modal
        open={openDecline}
        onCancel={handleCloseDecline}
        footer={null}
        width="35%"
        // centered
      >
        <Row justify="center">
          <Col span={24}>
            <div className="input-content-titulo">¿Estás seguro de rechazar la evidencia?</div>
          </Col>
        </Row>
        <Row justify="space-evenly" align="bottom">
          <Col xs={20} md={8} className="mt-3" al>
            <Button
              onClick={handleCloseDecline}
              variant="primary"
              danger
              className="button-styles-cancel"
            >
              Cancelar
            </Button>
          </Col>
          <Col xs={20} md={8} className="mt-3" al>
            <Button
              onClick={handleDecline}
              className="button-modal button-styles-add-element"
              type="primary"
              loading={loading}
            >
              Rechazar
            </Button>
          </Col>
        </Row>
      </Modal>
    </>
  );
}
